var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTcCabCapsuleNotesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 10.4V16.75C17.75 18.27 16.52 19.5 15 19.5H7C5.48 19.5 4.25 18.27 4.25 16.75V7C4.25 5.48 5.48 4.25 7 4.25H12.2",
    stroke: "#36F6FF",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.6L15.35 5.25C16.04 4.56 17.16 4.56 17.85 5.25C18.54 5.94 18.54 7.06 17.85 7.75L10.5 15.1L7.3 15.8L8 12.6Z",
    stroke: "#36F6FF",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcCabCapsuleNotesIcon);
export default __webpack_public_path__ + "static/media/tc_cab_capsule_notes_icon.a849f4faa4bb1fb1720362ab9b1dc9f6.svg";
export { ForwardRef as ReactComponent };